import React, { Component } from 'react';
import classes from "./ImageContainer.module.css";
import axios from '../../axios-shots';
import uuid from 'uuid';
import { Stage, Layer, Image, Tag, Text, Label, Circle } from 'react-konva';
import ToolsContainer from '../ToolsContainer/ToolsContainer';
import Portal from '../../components/Portal/Portal';
import BadWords from "bad-words"
import Konva from "konva"
import Drawing from '../../components/Tools/Drawing/Drawing'
import Modal from '../../components/UI/Modal/Modal';
import Prompt from '../../components/UI/Prompt/Prompt';
import '../../Transitions.css';
import triggerPlay from '../../util';


class ImageContainer extends Component {
    state = {
        showImageContainer: true,
        canvasHeight: 0,
        canvasWidth: 0,
        image: null,
        commentsArray: [],
        textAreaValue: "",
        isEditing: false,
        hasDrawn: false,
        isErasing: false,
        brushColor: "red",
        brushSize: 5,
        label: {
            x: 150,
            y: 150,
            height: 0,
            width: 0,
            comment: ""
        },
        isMouseOnLayer: false,
        mouseLayerPos: {
            x: 0,
            y: 0
        },
        showModal: false,
        showPrompt: false,
    }

    componentDidMount() {
        const imgObj = new window.Image();
        imgObj.src = this.props.img;

        imgObj.onload = () => {
            this.setState({ image: imgObj, canvasWidth: window.innerWidth, canvasHeight: window.innerHeight * .92, imgSrc: this.props.img }) //This set the canvas width and height. Reduced by 92%
        }
    }
    componentWillUnmount() {
        if (this.props.pauseOnShot) {
            triggerPlay();
        }
    }


    displayContainerHandler = () => {
        this.props.showImageContainer(!this.state.showImageContainer)
    }

    // downloadImageHandler = () => {                                   This function downloads the image
    //     let url = this.getStageURLHandler()
    //     let a = document.createElement('a');
    //     a.href = url.replace("image/png", "image/octet-stream");
    //     a.download = 'shot.png';
    //     a.click();
    // }

    submitImageHandler = () => {
        let url = this.getStageURLHandler();
        this.setState({ showPrompt: true })

        if (this.state.commentsArray.length > 0) {

            let timeStamp = new Date();
            let timeStampStr = timeStamp.toDateString() + " " + timeStamp.toLocaleTimeString();
            let submittedImage = {
                uuid: uuid.v4(),
                url: url,
                timeStamp: timeStampStr
            }

            axios.post('/screenshots.json', submittedImage)
                .then(response => {
                    this.setState({ showPrompt: false })
                    response.status === 200 ? this.props.notify(true, "Screenshot Saved! ") : this.props.notify(false)
                    this.setState({ showImageContainer: false })
                    this.props.storeImageToArrayHandler(submittedImage)
                })
                .catch(error => {
                    this.setState({ showPrompt: false })
                    this.props.notify(false, "Unable to save Screenshot. " + error)
                    this.props.storeImageToArrayHandler("")
                })
        }
    }

    cancelImageHandler = () => {
        if (this.state.commentsArray.length > 0 || this.state.hasDrawn) {
            this.setState({ showModal: true })
        } else {
            this.props.showImageContainer(!this.state.showImageContainer)
            this.props.notify(false, "Image Discarded.")
        }
    }

    modalVisibilityHandler = () => {
        this.setState({ showModal: !this.state.showModal })
    }

    promptVisibilityHandler = () => {
        this.setState({ showPrompt: !this.state.showPrompt })
    }

    getStageURLHandler = () => {
        let stageRef = this.refs.stage
        let url = stageRef ? stageRef.toDataURL() : null
        return url
    }

    onDragStartHandler = e => {
        e.target.setAttrs({
            shadowOffset: {
                x: 15,
                y: 15
            },
            scaleX: 1.1,
            scaleY: 1.1
        });
    };

    onDragEndHandler(event, comment) {
        this.setState({
            commentsArray: this.state.commentsArray.map(c => (c.uuid === comment.uuid ? Object.assign({}, c, { x: event.target.attrs.x, y: event.target.attrs.y }) : c))
        })
        event.target.to({
            duration: 0.5,
            easing: Konva.Easings.ElasticEaseOut,
            scaleX: 1,
            scaleY: 1,
            shadowOffsetX: 5,
            shadowOffsetY: 5
        });
    }

    onDblClickHandler(event, comment) {
        // console.log(event.target.getAbsolutePosition())
        // console.log(event.target)
        let nodeHeight = event.target.textHeight * 2
        let nodeWidth = event.target.textWidth * 2
        let textPosition = event.target.getAbsolutePosition()
        let stageNode = event.target.parent.parent.parent
        let stageBoundary = stageNode.getContainer().getBoundingClientRect();
        let labelPosition = {
            y: textPosition.y + stageBoundary.top,  //Calculating the position of the text node
            x: (textPosition.x + stageBoundary.left) - 20,
            height: nodeHeight,
            width: nodeWidth,
            comment: comment
        }
        // console.log("areaPosition x: " + areaPosition.x + " areaPosition.y: " + areaPosition.y)
        this.setState({ isEditing: true })
        this.setState(state => ({
            label: {
                ...state.label,
                ...labelPosition
            }
        }))
    }

    onMouseStageEnterHandler() {
        document.body.style.cursor = "crosshair";
    }

    onMouseLabelEnterHandler() {
        document.body.style.cursor = "pointer";
    }
    onMouseLabelLeaveHandler() {
        document.body.style.cursor = "crosshair";
    }
    onMouseStageLeaveHandler() {
        document.body.style.cursor = "default";
    }

    onMouseLayerMoveHandler(event) {
        let mPos = {
            onLayer: true,
            x: event.evt.layerX,
            y: event.evt.layerY
        }

        this.setState(state => ({
            mouseLayerPos: {
                ...state.mouseLayerPos,
                ...mPos
            }
        }))
    }

    onMouseLayerEnterHandler = () => {
        this.setState({ isMouseOnLayer: true })
    }

    onMouseLayerLeaveHandler = () => {
        this.setState({ isMouseOnLayer: false })
    }

    deleteHandler = comment => {
        const commentsArray = this.state.commentsArray.filter(b => b.uuid !== comment.uuid);
        this.setState({ commentsArray });
    };

    getCommentHandler = (comment) => {
        this.setState({
            commentsArray: [...this.state.commentsArray, comment]
        })
    }

    saveCommentHandler = (event, comment) => {
        let input = event.target.value
        let bw = new BadWords()

        if (event.key === 'Enter') {
            if (input === "" || input.trim() === "") {
                input = comment.value
            }
            this.setState({
                isEditing: false,
                commentsArray: this.state.commentsArray.map(
                    c => (c.uuid === comment.uuid ? Object.assign({}, c, { value: bw.clean(input) }) : c)
                ),
                textAreaValue: ""
            })
        }
    }

    inputChangeHandler = (event) => {
        this.setState({ textAreaValue: event.target.value })
    }

    eraserHandler = () => {
        this.setState({ isErasing: true })
    }

    brushHandler = () => {
        this.setState({ isErasing: false })
    }

    changeBrushSizeHandler = (value) => {
        this.setState({ brushSize: value })
    }

    brushColorHandler = (color) => {
        this.setState({ brushColor: color })
    }

    hasDrawnHandler = (status) => {
        this.setState({ hasDrawn: status })
    }

    render() {
        let portal = (
            <Portal>
                <input
                    type="text"
                    style={{
                        position: 'absolute',
                        top: this.state.label.y,
                        left: this.state.label.x,
                        width: this.state.label.width,
                        height: this.state.label.height,
                        border: "none",
                        borderColor: "transparent"
                    }}
                    placeholder={"Press 'Enter' to save comment."}
                    value={this.state.textAreaValue}
                    onChange={this.inputChangeHandler}
                    onKeyUp={(e) => this.saveCommentHandler(e, this.state.label.comment)}
                />
            </Portal>
        )
        let container = (
            <div style={{ width: this.state.canvasWidth, height: this.state.canvasHeight }}>

                <Stage className={classes.StageContainer} ref="stage" height={this.state.canvasHeight} width={this.state.canvasWidth} onMouseEnter={this.onMouseStageEnterHandler} onMouseLeave={this.onMouseStageLeaveHandler} >
                    <Layer>
                        <Image image={this.state.image} height={this.state.canvasHeight + (this.state.canvasHeight * .09)} width={this.state.canvasWidth} />
                        {
                            this.state.isMouseOnLayer ?
                                <Circle
                                    x={this.state.mouseLayerPos.x}
                                    y={this.state.mouseLayerPos.y}
                                    radius={this.state.brushSize * .5} //For some reason, brushSize in px does not match radius of shape, Shape radius reduced by 50% to match stroke size.
                                    stroke={this.state.brushColor}
                                /> : null
                        }
                    </Layer>
                    <Layer onMouseMove={(e) => this.onMouseLayerMoveHandler(e)} onMouseEnter={this.onMouseLayerEnterHandler} onMouseLeave={this.onMouseLayerLeaveHandler}>
                        <Drawing
                            mode={this.state.isErasing ? 'eraser' : 'brush'}
                            brushSize={this.state.brushSize}
                            canvasHeight={this.state.canvasHeight}
                            canvasWidth={this.state.canvasWidth}
                            brushColor={this.state.brushColor}
                            hasDrawnHandler={(status) => this.hasDrawnHandler(status)}
                        />
                    </Layer>
                    <Layer>
                        {this.state.isEditing ? portal : null}
                        {this.state.commentsArray.map(comment => (
                            <Label
                                key={comment.uuid}
                                draggable={true}
                                x={comment.x}
                                y={comment.y}
                                onDragStart={this.onDragStartHandler}
                                onDragEnd={(e) => { this.onDragEndHandler(e, comment) }}
                                onMouseEnter={this.onMouseLabelEnterHandler}
                                onMouseLeave={this.onMouseLabelLeaveHandler}
                            >
                                <Tag
                                    fill="black"
                                    pointerWidth={10}
                                    pointerHeight={10}
                                    lineJoin='round'
                                    shadowColor='black'
                                />
                                <Text
                                    text={comment.value}
                                    fontFamily='Calibri'
                                    fontSize={18}
                                    padding={5}
                                    fill='white'
                                    onDblClick={(e) => { this.onDblClickHandler(e, comment) }}
                                    onDblTap={(e) => { this.onDblClickHandler(e, comment) }}
                                />

                                <Text
                                    text="[x]"
                                    fontFamily='Calibri'
                                    fontSize={18}
                                    x={-20}
                                    fill='black'
                                    onClick={() => this.deleteHandler(comment)}

                                />
                            </Label>
                        ))}
                    </Layer>

                </Stage>

                <ToolsContainer
                    // className={classes.ImageContainer}
                    downloadImageHandler={() => this.downloadImageHandler()}
                    getCommentHandler={comment => this.getCommentHandler(comment)}
                    eraserHandler={this.eraserHandler}
                    brushHandler={this.brushHandler}
                    isErasing={this.state.isErasing}
                    changeBrushSizeHandler={value => this.changeBrushSizeHandler(value)}
                    brushSize={this.state.brushSize}
                    brushColorHandler={(color) => this.brushColorHandler(color)}
                    displayContainerHandler={() => this.displayContainerHandler}
                    submitImageHandler={() => this.submitImageHandler}
                    cancelImageHandler={() => this.cancelImageHandler}
                />

                {this.state.showModal ? <Modal modalVisibilityHandler={this.modalVisibilityHandler} showModal={this.state.showModal} displayContainerHandler={this.displayContainerHandler} notify={this.props.notify} /> : null}
                {this.state.showPrompt ? <Prompt forSubmission={this.state.commentsArray.length > 0} promptVisibilityHandler={this.promptVisibilityHandler} /> : null}

            </div>

        )

        return (
            <div className={classes.ImageContainer}>
                {this.state.image ? container : null}
            </div>
        )
    }
}
export default ImageContainer;